/**
 * Sound Bath Mixer: anteprima audio in griglia collezione.
 * Card tema: [data-product-main-grid] · Globo: .spf-product-card
 * Osserva #gf-products (solo nuove card): Globo può rimuovere/sostituire #gf-products.
 * Senza category_id in pagina non chiama l'API.
 */
(function () {
  var GRID_ROOT_ID = 'gf-products';
  var COLLECTION_CONTAINER_ID = 'CollectionProductsContainer';
  var MOUNT_CLASS = 'sbm-grid-audio';
  var DONE_ATTR = 'data-sbm-actions-mounted';
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function fillIconPlay(el) {
    el.textContent = '';
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', MOUNT_CLASS + '__glyph');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '11');
    svg.setAttribute('height', '11');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('d', 'M8 6.5v11l9.5-5.5L8 6.5z');
    svg.appendChild(path);
    el.appendChild(svg);
  }

  function fillIconPause(el) {
    el.textContent = '';
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', MOUNT_CLASS + '__glyph');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '11');
    svg.setAttribute('height', '11');
    svg.setAttribute('aria-hidden', 'true');
    var a = document.createElementNS(SVG_NS, 'path');
    a.setAttribute('fill', 'currentColor');
    a.setAttribute('d', 'M7 6h3.5v12H7V6zm6.5 0H17v12h-3.5V6z');
    svg.appendChild(a);
    el.appendChild(svg);
  }

  function fillCartIcon(el) {
    el.textContent = '';
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', MOUNT_CLASS + '__cart-glyph');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.75');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute(
      'd',
      'M2.05 2.05h2l2.66 12.42a2 2 0 002 1.61h9.72a2 2 0 002-1.61l1.08-5.29H5.12'
    );
    var c1 = document.createElementNS(SVG_NS, 'circle');
    c1.setAttribute('cx', '8');
    c1.setAttribute('cy', '21');
    c1.setAttribute('r', '1');
    var c2 = document.createElementNS(SVG_NS, 'circle');
    c2.setAttribute('cx', '19');
    c2.setAttribute('cy', '21');
    c2.setAttribute('r', '1');
    svg.appendChild(path);
    svg.appendChild(c1);
    svg.appendChild(c2);
    el.appendChild(svg);
  }

  function gridAddToCartAvailable(card) {
    if (!card) return false;
    if (card.classList.contains('spf-soldout')) return false;
    if (card.querySelector('.yv-product-badge.sold-badge')) return false;
    var globoBtn = card.querySelector('.spf-product__form-btn-addtocart');
    if (globoBtn) return !globoBtn.disabled;
    var form = card.querySelector('form[data-product-form]');
    if (!form) return false;
    var sub =
      form.querySelector('button.Sd_addProduct[type="submit"]') ||
      form.querySelector('button[type="submit"]');
    return !!(sub && !sub.disabled);
  }

  function triggerGridAddToCart(card, ev) {
    if (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    var globoBtn = card.querySelector('.spf-product__form-btn-addtocart');
    if (globoBtn && !globoBtn.disabled) {
      globoBtn.click();
      return;
    }
    var form = card.querySelector('form[data-product-form]');
    if (form) {
      var sub =
        form.querySelector('button.Sd_addProduct[type="submit"]') ||
        form.querySelector('button[type="submit"]');
      if (sub && !sub.disabled) {
        sub.click();
        return;
      }
      try {
        form.requestSubmit();
      } catch (err) {}
    }
  }

  var CARD_SELECTORS =
    '#' +
    COLLECTION_CONTAINER_ID +
    ' [data-product-main-grid],#' +
    COLLECTION_CONTAINER_ID +
    ' .spf-product-card,#' +
    GRID_ROOT_ID +
    ' [data-product-main-grid],#' +
    GRID_ROOT_ID +
    ' .spf-product-card,.yv-collection-products [data-product-main-grid],.yv-collection-products .spf-product-card';

  var DEFAULT_PLAYER_BASE = 'https://exclusive.vibrasonic.it/Sound_Bath_Mixer/public';
  var INSTRUMENTS_CACHE_KEY = 'sbm-grid-instruments-v1';
  var INSTRUMENTS_CACHE_TTL_MS = 60 * 60 * 1000;

  function stripTrailingSlash(url) {
    if (!url || typeof url !== 'string') return '';
    return url.replace(/\/+$/, '');
  }

  function playerBaseFromApiUrl(url) {
    if (!url) return '';
    var marker = '/api/griglia-data.php';
    var idx = url.indexOf(marker);
    if (idx > 0) return stripTrailingSlash(url.slice(0, idx));
    return '';
  }

  function getPlayerBase() {
    var nodes = document.querySelectorAll('[data-sbm-player-base], [data-griglia-api]');
    for (var i = 0; i < nodes.length; i++) {
      var explicit = nodes[i].getAttribute('data-sbm-player-base');
      if (explicit) return stripTrailingSlash(explicit);
      var fromApi = playerBaseFromApiUrl(nodes[i].getAttribute('data-griglia-api'));
      if (fromApi) return fromApi;
    }
    var container = document.getElementById(COLLECTION_CONTAINER_ID);
    if (container) {
      var base = container.getAttribute('data-sbm-player-base');
      if (base) return stripTrailingSlash(base);
    }
    return DEFAULT_PLAYER_BASE;
  }

  function getPageApiUrls() {
    var nodes = document.querySelectorAll('[data-griglia-api]');
    var urls = [];
    for (var i = 0; i < nodes.length; i++) {
      var url = nodes[i].getAttribute('data-griglia-api');
      if (url && urls.indexOf(url) === -1) urls.push(url);
    }
    return urls;
  }

  function resolveApiConfig() {
    var pageUrls = getPageApiUrls();
    if (pageUrls.length) {
      return { urls: pageUrls, useGlobalCache: false };
    }
    // Senza category_id esplicita non scansionare 1..30:
    // su collezioni come /diapason genera solo 404 inutili in console.
    return { urls: [], useGlobalCache: false };
  }

  function loadCachedInstruments(base) {
    try {
      var raw = sessionStorage.getItem(INSTRUMENTS_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !Array.isArray(parsed.instruments)) return null;
      if (Date.now() - parsed.ts > INSTRUMENTS_CACHE_TTL_MS) return null;
      if (stripTrailingSlash(parsed.base || '') !== stripTrailingSlash(base || '')) return null;
      return parsed.instruments;
    } catch (e) {
      return null;
    }
  }

  function saveCachedInstruments(base, instruments) {
    try {
      sessionStorage.setItem(
        INSTRUMENTS_CACHE_KEY,
        JSON.stringify({
          ts: Date.now(),
          base: stripTrailingSlash(base),
          instruments: instruments || [],
        })
      );
    } catch (e) {}
  }

  function normalizeHandle(handle) {
    if (!handle || typeof handle !== 'string') return '';
    return handle.toLowerCase().trim();
  }

  function buildInstrumentIndex(instruments) {
    var byHandle = Object.create(null);
    if (!instruments || !instruments.length) return byHandle;
    for (var i = 0; i < instruments.length; i++) {
      var ins = instruments[i];
      if (!ins || !ins.audio_url) continue;
      var p = parseInstrumentProductUrl(ins.product_url || '');
      if (!p || !p.handle) continue;
      var key = normalizeHandle(p.handle);
      if (!byHandle[key]) byHandle[key] = [];
      var iv =
        ins.shopify_variant_id != null && ins.shopify_variant_id !== ''
          ? String(ins.shopify_variant_id)
          : p.variant;
      byHandle[key].push({ ins: ins, variant: iv });
    }
    return byHandle;
  }

  function pickInstrumentFromIndex(index, productHandle, firstVariantId) {
    if (!index || !productHandle) return null;
    var list = index[normalizeHandle(productHandle)];
    if (!list || !list.length) return null;
    if (list.length === 1) return list[0].ins;
    var v =
      firstVariantId != null && firstVariantId !== '' ? String(firstVariantId) : null;
    if (v) {
      for (var j = 0; j < list.length; j++) {
        if (list[j].variant && list[j].variant === v) return list[j].ins;
      }
    }
    return list[0].ins;
  }

  function parseInstrumentProductUrl(url) {
    if (!url || typeof url !== 'string') return null;
    try {
      var u = new URL(url, window.location.origin);
      var parts = u.pathname.split('/').filter(Boolean);
      var pi = parts.indexOf('products');
      var handle = pi >= 0 && parts[pi + 1] ? decodeURIComponent(parts[pi + 1]) : null;
      var variant = u.searchParams.get('variant');
      return { handle: handle, variant: variant ? String(variant) : null };
    } catch (e) {
      return null;
    }
  }

  function getCardHandleAndVariant(card) {
    if (card.getAttribute('data-product-handle')) {
      return {
        handle: card.getAttribute('data-product-handle'),
        variantId: card.getAttribute('data-product-first-variant-id'),
      };
    }
    var link = card.querySelector(
      'a.spf-product-card__image-wrapper[href], .spf-product-card__title a[href], a[href*="/products/"]'
    );
    if (!link) return null;
    var href = link.getAttribute('href');
    if (!href || href.indexOf('javascript:') === 0) return null;
    var parsed = parseInstrumentProductUrl(href);
    if (!parsed || !parsed.handle) return null;
    var sel = card.querySelector('select.spf-product__variants');
    var vid = null;
    if (sel && sel.selectedOptions && sel.selectedOptions.length) {
      vid = sel.selectedOptions[0].value;
    } else if (parsed.variant) {
      vid = parsed.variant;
    }
    return { handle: parsed.handle, variantId: vid };
  }

  function createAudioButton(instrument) {
    if (!instrument || !instrument.audio_url) return null;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = MOUNT_CLASS + '__btn';
    btn.setAttribute('aria-label', 'Ascolta anteprima audio');
    btn.setAttribute('aria-pressed', 'false');
    var icon = document.createElement('span');
    icon.className = MOUNT_CLASS + '__icon';
    icon.setAttribute('aria-hidden', 'true');
    fillIconPlay(icon);
    btn.appendChild(icon);
    btn.appendChild(document.createTextNode(' Ascolta'));
    var src = instrument.audio_url;
    var startSec = instrument.audio_start_sec;
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      if (activeBtn === btn && sharedAudio && !sharedAudio.paused) {
        stopActive();
        return;
      }
      playForButton(btn, src, startSec);
    });
    return btn;
  }

  function appendAudioToWrap(wrap, instrument) {
    if (!wrap || !instrument || !instrument.audio_url) return;
    if (wrap.querySelector('.' + MOUNT_CLASS + '__btn')) return;
    var btn = createAudioButton(instrument);
    if (btn) wrap.appendChild(btn);
  }

  function ensureStyles() {
    var c = MOUNT_CLASS;
    var s = document.getElementById('sbm-grid-audio-styles');
    if (!s) {
      s = document.createElement('style');
      s.id = 'sbm-grid-audio-styles';
      document.head.appendChild(s);
    }
    s.textContent =
      '.' +
      c +
      '{margin-top:0.75rem;display:inline-flex;align-items:center;gap:0.4rem;flex-shrink:0}' +
      '.' +
      c +
      '__btn{' +
      'display:inline-flex;align-items:center;justify-content:center;' +
      'gap:0.45rem;min-height:2.25rem;padding:0.35rem 0.85rem 0.35rem 0.4rem;' +
      'font-family:inherit;font-size:0.8125rem;font-weight:600;letter-spacing:0.03em;' +
      'color:#145a52;' +
      'background:linear-gradient(180deg,#fff 0%,#f3faf8 100%);' +
      'border:1px solid rgba(74,155,142,0.38);border-radius:999px;cursor:pointer;' +
      '-webkit-tap-highlight-color:transparent;tap-highlight-color:transparent;' +
      '-webkit-touch-callout:none;touch-action:manipulation;' +
      '-webkit-appearance:none;appearance:none;' +
      'box-shadow:0 1px 2px rgba(20,90,82,0.06),0 4px 14px rgba(74,155,142,0.12);' +
      'transition:color .2s ease,background .2s ease,border-color .2s ease,box-shadow .2s ease,transform .2s ease' +
      '}' +
      '@media (max-width:767px){.' +
      c +
      '__btn{font-size:0.75rem;min-height:2.05rem;padding:0.3rem 0.7rem 0.3rem 0.35rem;gap:0.35rem}}' +
      '.' +
      c +
      '-row{display:flex;align-items:center;justify-content:space-between;gap:0.5rem;width:100%;flex-wrap:nowrap}' +
      '.' +
      c +
      '-row .' +
      c +
      '{margin-top:0}' +
      '.' +
      c +
      '-row .spf-product-card__price-wrapper,' +
      '.' +
      c +
      '-row .yv-prizebox{flex:1;min-width:0;text-align:left}' +
      '.' +
      c +
      '__atc{' +
      'display:inline-flex;align-items:center;justify-content:center;' +
      'width:38px;height:38px;padding:0;flex-shrink:0;' +
      'color:#2a6d62;' +
      'background:#fff;' +
      'border:1px solid rgba(74,155,142,0.32);border-radius:10px;cursor:pointer;' +
      '-webkit-tap-highlight-color:transparent;tap-highlight-color:transparent;' +
      '-webkit-touch-callout:none;touch-action:manipulation;' +
      '-webkit-appearance:none;appearance:none;' +
      'box-shadow:0 1px 0 rgba(255,255,255,0.9) inset,0 1px 3px rgba(20,90,82,0.07);' +
      'transition:color .2s ease,background .2s ease,border-color .2s ease,box-shadow .2s ease,transform .2s ease,opacity .2s ease' +
      '}' +
      '@media (max-width:767px){.' +
      c +
      '__atc{width:36px;height:36px;border-radius:9px}.' +
      c +
      '__atc-inner .' +
      c +
      '__cart-glyph{width:19px;height:19px}}' +
      '.' +
      c +
      '__atc:hover:not(:disabled){' +
      'color:#145a52;' +
      'background:#f6fbfa;' +
      'border-color:rgba(61,133,121,0.48);' +
      'box-shadow:0 1px 0 rgba(255,255,255,0.9) inset,0 3px 10px rgba(74,155,142,0.14);' +
      'transform:translateY(-1px)' +
      '}' +
      '.' +
      c +
      '__atc:active:not(:disabled){transform:translateY(0)}' +
      '.' +
      c +
      '__atc:focus-visible{outline:2px solid #4a9b8e;outline-offset:2px}' +
      '.' +
      c +
      '__atc:disabled{opacity:0.38;cursor:not-allowed;box-shadow:none}' +
      '.' +
      c +
      '__atc-inner{display:flex;align-items:center;justify-content:center;line-height:0}' +
      '.' +
      c +
      '__atc-inner .' +
      c +
      '__cart-glyph{' +
      'display:block;width:21px;height:21px;pointer-events:none;' +
      'overflow:visible;shape-rendering:auto;-webkit-backface-visibility:hidden;backface-visibility:hidden' +
      '}' +
      '.' +
      c +
      '__btn:hover{' +
      'color:#0c3d37;' +
      'background:linear-gradient(180deg,#fff 0%,#e8f4f1 100%);' +
      'border-color:rgba(61,133,121,0.55);' +
      'box-shadow:0 2px 6px rgba(20,90,82,0.08),0 8px 20px rgba(74,155,142,0.16);' +
      'transform:translateY(-1px)' +
      '}' +
      '.' +
      c +
      '__btn:active{transform:translateY(0);box-shadow:0 1px 3px rgba(20,90,82,0.08)}' +
      '.' +
      c +
      '__btn:focus-visible{outline:2px solid #4a9b8e;outline-offset:3px}' +
      '.' +
      c +
      '__btn[aria-pressed="true"]{' +
      'color:#fff;' +
      'background:linear-gradient(145deg,#419688 0%,#2f7569 55%,#265f55 100%);' +
      'border-color:rgba(255,255,255,0.12);' +
      'box-shadow:inset 0 1px 0 rgba(255,255,255,0.2),0 3px 12px rgba(38,95,85,0.35)' +
      '}' +
      '@keyframes sbm-audio-breathe{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.7;transform:scale(0.94)}}' +
      '.' +
      c +
      '__btn--loading{pointer-events:none;cursor:wait}' +
      '.' +
      c +
      '__btn--loading .' +
      c +
      '__icon{animation:sbm-audio-breathe .65s ease-in-out infinite}' +
      '.' +
      c +
      '__icon{' +
      'display:flex;align-items:center;justify-content:center;' +
      'width:1.5rem;height:1.5rem;flex-shrink:0;' +
      'line-height:0;color:#fff;' +
      'background:linear-gradient(145deg,#52ada0,#3a8f82);' +
      'border-radius:50%;' +
      'box-shadow:0 1px 3px rgba(38,95,85,0.35);' +
      '-webkit-tap-highlight-color:transparent;' +
      'transition:transform .2s ease,box-shadow .2s ease,background .2s ease' +
      '}' +
      '.' +
      c +
      '__icon .' +
      c +
      '__glyph{display:block;pointer-events:none}' +
      '.' +
      c +
      '__btn:hover .' +
      c +
      '__icon{transform:scale(1.05);box-shadow:0 2px 6px rgba(38,95,85,0.4)}' +
      '.' +
      c +
      '__btn[aria-pressed="true"] .' +
      c +
      '__icon{' +
      'background:rgba(255,255,255,0.22);' +
      'box-shadow:inset 0 1px 1px rgba(0,0,0,0.08)' +
      '}';
  }

  var sharedAudio = null;
  var activeBtn = null;

  function stopActive(btn) {
    if (sharedAudio) {
      try {
        sharedAudio.pause();
      } catch (e) {}
      sharedAudio = null;
    }
    if (activeBtn) {
      activeBtn.classList.remove(MOUNT_CLASS + '__btn--loading');
      activeBtn.removeAttribute('aria-busy');
      activeBtn.setAttribute('aria-pressed', 'false');
      activeBtn.setAttribute('aria-label', 'Ascolta anteprima audio');
      var ic = activeBtn.querySelector('.' + MOUNT_CLASS + '__icon');
      if (ic) fillIconPlay(ic);
    }
    activeBtn = btn || null;
  }

  function playForButton(btn, src, startSec) {
    stopActive();
    activeBtn = btn;
    var audio = new Audio();
    audio.preload = 'auto';
    audio.src = src;
    sharedAudio = audio;
    var start = 0;
    if (startSec != null && startSec !== '') {
      var n = parseFloat(startSec, 10);
      if (!isNaN(n) && n > 0) start = n;
    }
    btn.classList.add(MOUNT_CLASS + '__btn--loading');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('aria-label', 'Interrompi audio');
    var icon = btn.querySelector('.' + MOUNT_CLASS + '__icon');
    if (icon) fillIconPause(icon);

    function clearLoading() {
      btn.classList.remove(MOUNT_CLASS + '__btn--loading');
      btn.removeAttribute('aria-busy');
    }

    audio.addEventListener(
      'playing',
      function () {
        clearLoading();
      },
      { once: true }
    );
    audio.addEventListener('ended', function () {
      stopActive();
    });
    audio.addEventListener('error', function () {
      clearLoading();
      stopActive();
    });

    function attemptPlay() {
      var playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch(function (err) {
          if (err && err.name === 'AbortError') return;
          clearLoading();
          stopActive();
        });
      }
    }

    if (start > 0) {
      audio.addEventListener(
        'loadedmetadata',
        function () {
          try {
            audio.currentTime = start;
          } catch (e) {}
          attemptPlay();
        },
        { once: true }
      );
      audio.load();
    } else {
      attemptPlay();
    }
  }

  function mountProductActions(card, instrument) {
    var existingWrap = card.querySelector('.' + MOUNT_CLASS);
    if (existingWrap) {
      appendAudioToWrap(existingWrap, instrument);
      if (typeof window.vibrasonicInjectFreeShippingBar === "function") {
        window.vibrasonicInjectFreeShippingBar(card);
      }
      return;
    }
    var info = card.querySelector('.yv-product-information') || card.querySelector('.spf-product__info');
    if (!info) return;
    var wrap = document.createElement('div');
    wrap.className = MOUNT_CLASS;

    var atcBtn = document.createElement('button');
    atcBtn.type = 'button';
    atcBtn.className = MOUNT_CLASS + '__atc';
    atcBtn.setAttribute('aria-label', 'Aggiungi al carrello');
    var atcInner = document.createElement('span');
    atcInner.className = MOUNT_CLASS + '__atc-inner';
    fillCartIcon(atcInner);
    atcBtn.appendChild(atcInner);
    var canAtc = gridAddToCartAvailable(card);
    atcBtn.disabled = !canAtc;
    if (!canAtc) {
      atcBtn.setAttribute('title', 'Non disponibile');
    }
    atcBtn.addEventListener('click', function (ev) {
      if (atcBtn.disabled) return;
      triggerGridAddToCart(card, ev);
    });
    wrap.appendChild(atcBtn);

    var audioBtn = createAudioButton(instrument);
    if (audioBtn) wrap.appendChild(audioBtn);

    var priceWrap =
      info.querySelector('.spf-product-card__price-wrapper') || info.querySelector('.yv-prizebox');
    if (priceWrap) {
      var pr = priceWrap.parentElement;
      if (pr && pr.classList.contains(MOUNT_CLASS + '-row')) {
        pr.appendChild(wrap);
      } else {
        var row = document.createElement('div');
        row.className = MOUNT_CLASS + '-row';
        priceWrap.parentNode.insertBefore(row, priceWrap);
        row.appendChild(priceWrap);
        row.appendChild(wrap);
      }
    } else {
      info.appendChild(wrap);
    }
    if (typeof window.vibrasonicInjectFreeShippingBar === "function") {
      window.vibrasonicInjectFreeShippingBar(card);
    }
  }

  function enhanceCards(instruments) {
    var index = buildInstrumentIndex(instruments);
    var cards = document.querySelectorAll(CARD_SELECTORS);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var data = getCardHandleAndVariant(card);
      if (!data || !data.handle) continue;
      var ins = pickInstrumentFromIndex(index, data.handle, data.variantId);
      mountProductActions(card, ins);
      card.setAttribute(DONE_ATTR, '');
    }
    if (typeof window.vibrasonicInjectFreeShippingBar === 'function') {
      window.vibrasonicInjectFreeShippingBar();
    }
  }

  function getObserveRoot() {
    return (
      document.getElementById(COLLECTION_CONTAINER_ID) ||
      document.querySelector('.yv-collection-products') ||
      document.getElementById(GRID_ROOT_ID)
    );
  }

  function init() {
    var apiConfig = resolveApiConfig();
    if (!apiConfig.urls.length) return;
    var observeRoot = getObserveRoot();
    if (!observeRoot) return;

    ensureStyles();

    var instrumentsCache = null;
    var fetchStarted = false;
    var debounceTimer = null;
    var gridObserver = null;
    var gridParentObserver = null;
    var ENHANCE_DEBOUNCE_MS = 150;
    var playerBase = getPlayerBase();

    function fetchAllInstruments(urls) {
      return Promise.all(
        urls.map(function (url) {
          return fetch(url)
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              return data && Array.isArray(data.instruments) ? data.instruments : [];
            })
            .catch(function () {
              return [];
            });
        })
      ).then(function (lists) {
        var merged = [];
        var seen = Object.create(null);
        for (var i = 0; i < lists.length; i++) {
          var list = lists[i];
          for (var j = 0; j < list.length; j++) {
            var ins = list[j];
            if (!ins) continue;
            var key =
              String(ins.id || '') +
              '|' +
              (ins.product_url || '') +
              '|' +
              (ins.audio_url || '');
            if (seen[key]) continue;
            seen[key] = true;
            merged.push(ins);
          }
        }
        return merged;
      });
    }

    function loadAndEnhance() {
      if (instrumentsCache) {
        enhanceCards(instrumentsCache);
        return;
      }
      if (apiConfig.useGlobalCache) {
        var cached = loadCachedInstruments(playerBase);
        if (cached) {
          instrumentsCache = cached;
          enhanceCards(instrumentsCache);
          return;
        }
      }
      if (fetchStarted) return;
      fetchStarted = true;
      fetchAllInstruments(apiConfig.urls)
        .then(function (merged) {
          instrumentsCache = merged;
          if (apiConfig.useGlobalCache) {
            saveCachedInstruments(playerBase, merged);
          }
          enhanceCards(instrumentsCache);
        })
        .finally(function () {
          fetchStarted = false;
        });
    }

    function scheduleEnhance() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        debounceTimer = null;
        loadAndEnhance();
      }, ENHANCE_DEBOUNCE_MS);
    }

    function bindGridObserver() {
      var grid = document.getElementById(GRID_ROOT_ID);
      if (!grid) return;
      if (gridObserver) {
        gridObserver.disconnect();
        gridObserver = null;
      }
      gridObserver = new MutationObserver(function (mutations) {
        var hasNewCards = mutations.some(function (m) {
          return m.addedNodes.length > 0;
        });
        if (hasNewCards) scheduleEnhance();
      });
      gridObserver.observe(grid, { childList: true, subtree: false });
    }

    function bindGridParentObserver() {
      var grid = document.getElementById(GRID_ROOT_ID);
      var parent = grid ? grid.parentElement : null;
      if (!parent) return;
      if (gridParentObserver) {
        gridParentObserver.disconnect();
        gridParentObserver = null;
      }
      gridParentObserver = new MutationObserver(function (mutations) {
        var gridReplaced = mutations.some(function (m) {
          for (var i = 0; i < m.addedNodes.length; i++) {
            var node = m.addedNodes[i];
            if (node.nodeType === 1 && node.id === GRID_ROOT_ID) return true;
          }
          return false;
        });
        if (gridReplaced) {
          bindGridObserver();
          scheduleEnhance();
        }
      });
      gridParentObserver.observe(parent, { childList: true, subtree: false });
    }

    loadAndEnhance();
    bindGridObserver();
    bindGridParentObserver();

    window.addEventListener('load', function () {
      bindGridObserver();
      scheduleEnhance();
    });

    setTimeout(function () {
      bindGridObserver();
      scheduleEnhance();
    }, 800);

    setTimeout(function () {
      scheduleEnhance();
    }, 2500);
  }

  function boot() {
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
